import React from 'react';
import { ROUTE_NAMES } from '@atlassian/jira-common-constants/src/spa-routes';
import { AsyncGlobalAppsSettingsSidebar } from '@atlassian/jira-navigation-apps-sidebar-nav4-global-settings-apps-settings';
import { AsyncGlobalIssuesSettingsSidebar } from '@atlassian/jira-navigation-apps-sidebar-nav4-global-settings-issues-settings';
import { AsyncGlobalProductsSettingsSidebar } from '@atlassian/jira-navigation-apps-sidebar-nav4-global-settings-products-settings';
import { AsyncGlobalProjectsSettingsSidebar } from '@atlassian/jira-navigation-apps-sidebar-nav4-global-settings-projects-settings';
import { AsyncGlobalSystemSettingsSidebar } from '@atlassian/jira-navigation-apps-sidebar-nav4-global-settings-system-settings';
import AsyncSidebarContent from '@atlassian/jira-navigation-apps-sidebar-nav4-sidebar-content/src/async';
import { useCurrentRoute } from '@atlassian/jira-platform-router-utils';

export const SidebarSelector = () => {
	const route = useCurrentRoute();

	switch (route.name) {
		case ROUTE_NAMES.MARKETPLACE_INDEX:
			return <AsyncGlobalAppsSettingsSidebar />;
		case ROUTE_NAMES.GLOBAL_SETTINGS_ISSUE_TYPES:
			return <AsyncGlobalIssuesSettingsSidebar />;
		case ROUTE_NAMES.PRODUCTS_JSW_CONFIGURATION:
			return <AsyncGlobalProductsSettingsSidebar />;
		case ROUTE_NAMES.PROJECTS_DIRECTORY_MANAGE:
			return <AsyncGlobalProjectsSettingsSidebar />;
		case ROUTE_NAMES.SYSTEM_CONFIGURATION:
			return <AsyncGlobalSystemSettingsSidebar />;
		default:
			return <AsyncSidebarContent />;
	}
};
